/**
 * Initialize string format utility
 * Adds the format command for adding parameters to strings. For Example:
 *    'This is a test: {testName}'.format({testName: 'Test Hello World'})
 */
export const initializeStringFormat = () => {
    if (!String.prototype.format) {
        // eslint-disable-next-line
        String.prototype.format = function (values) {
            return this.replace(/{(\w+)}/g, function (match, key) {
                return typeof values[key] !== 'undefined' ? values[key] : match
            })
        }
    }
}